<template>
  <v-menu
    v-model="notificationsMenu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
    class="notifications-btn"
    content-class="notifications"
  >
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on" medium class="notifications-btn">
        <v-icon medium>{{ (newNotifications ? 'mdi-bell' : 'mdi-bell-outline' ) }}</v-icon>
        <v-icon v-if="newNotifications" small color="red" class="notification-alert-icon">mdi-exclamation-thick</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-subtitle class="sub-notifications">{{ lang.notifications.title }}</v-card-subtitle>
      <v-list dense>
        <router-link
          v-for="(notification, index) in get_data.notifications"
          :key="index"
          v-show="notification.unread"
          link
          :to="{ name: notification.route }"
          tag="div"
          exact
        >
          <v-list-item link>
            <v-list-item-action>
              <v-icon>{{ lang[notification.route].icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ `${notification.unread} ${lang[notification.route].title}` }}{{ `${(notification.unread > 1 ? 's' : '')} ${lang.notifications.unread((notification.unread > 1))}` }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import appdata from '@/mixins/appdata'

export default {
  mixins: [ appdata ],
  data: () => ({
    notificationsMenu: false
  }),
  computed: {
    newNotifications () {
      var notifications = Object.values(this.get_data.notifications).reduce((a, b) => a + b.unread, 0)
      return (notifications > 0)
    }
  }
}
</script>
